const getSearchConfig = function (state, context) {
  return Object.values(state)
    .filter((boItem) => boItem[context])
    .map((item) => {
      const { type, subType } = item;
      return {
        context,
        type,
        subType,
        position: item[context].position,
      };
    });
};

const getters = {
  getSearchConfig: (state) => (context) => getSearchConfig(state, context),
  getSearchCriteria: (state) => (type) => state[type].searchCriteria || [],
};

export default getters;
